import { PagesMap } from "../../app/pages/pagesMap";
import type { UUID } from "../../typings/global";
import { UUID_PLACEHOLDER } from "../constants";
import { getAppName } from "./utils";
import { regexPatterns } from "./validationUtils";

export const replaceUrlUuidsWithPlaceholders = (path: string) => {
  const uuids: UUID[] = [];

  const outputPath =
    "/" +
    path
      .substring(1)
      .split("/")
      .map((pathPart) => {
        const uuid = pathPart.match(regexPatterns.uuidRegex)?.[0];
        if (uuid) {
          uuids.push(uuid);
          return UUID_PLACEHOLDER;
        }
        return pathPart;
      })
      .join("/");

  return { path: outputPath, uuids };
};

export const replaceUrlPlaceholdersWithUuids = (path: string, uuids: UUID[]) => {
  let index = 0;
  return path.replaceAll(UUID_PLACEHOLDER, () => uuids[index++] as string);
};

export const resolvePageTitle = (path: string) => {
  const page = PagesMap.get(replaceUrlUuidsWithPlaceholders(path).path);
  const appName = getAppName();
  return page ? `${page.title} | ${appName}` : `${appName}`;
};
